import { FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL, FETCH_CONSIGNMENTS_CUSTOMER_COUNT_NO_REPLENISH_CUST, CONSIGNMENTS_CUSTOMER_INVENTORY_REPLENISH_CHANGE, FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH, FETCH_ALL_THIRD_PARTY_PERMISSIONS, FETCH_USER_THIRD_PARTY_PERMISSIONS, FETCH_CONSIGNMENTS_CUSTOMER_COUNTEDIT, CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND, RESET_CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND, FETCH_CONSIGNMENTS_CUSTOMER_INVENTORY, NOTICE_MESSAGE, FETCH_USER_CUSTOMER_PERMISSIONS, ADD_CONSIGNMENT_POPUP, FETCH_USER_CONSIGNMENTS_CUSTOMER, FETCH_CONSIGNMENTS_CUSTOMER, FETCH_CONSIGNMENTS_PRODUCT, FETCH_DELETE_ROW, FETCH_EDIT_ROW, FETCH_INSERT_ITEMS_ROW } from '../actions/actionTypes';

const initialState = {
    items_fetchConsignmentsProduct: [],
    items_fetchConsignmentsCustomer: [],
    items_fetchUserConsignmentsCustomer: [],
    items_fetchConsignmentsCustomerInventory: [],
    items_fetchConsignmentsCustomerInventoryCountEdit: [],
    items_fetchConsignmentsCustomerInventoryCountReplenish: [],
    items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: [],
    // items_consignmentsCustomerInventoryOnhand: [{'CUSTID':null, 'PRDID': null, 'ONHAND':null}],
    items_fetchConsignmentsCustomerInventoryCountReplenishDetail: {},
    items_consignmentsCustomerInventoryReplenishChange: {}, 
    items_consignmentsCustomerInventoryOnhand: {},    

    fetchCustno_check: false,
    items_addConsignmentPopup: {
        showModel: null,
        custnoClicked: null,
        prdidClicked: null,
        partnoClicked: null,
        custClickedDetails: [],
        consignmentClickedDetails:[],
    },   
    items_fetchUserCustomer: [],
    items_fetchUserThirdParty: [],
    items_noticeMessage: '',
    items_fetchAllThirdParty: [],
}

const consignmentsPostReducer = (state = initialState, action) => {
    //console.log('consignmentsPostReducer called state:' + JSON.stringify(state) + ' action:' + JSON.stringify(action));

    switch(action.type){
        case FETCH_CONSIGNMENTS_PRODUCT:
            return {
                ...state,
                items_fetchConsignmentsProduct: action.payload,
                items_fetchUserConsignmentsCustomer: []
            }
        case FETCH_CONSIGNMENTS_CUSTOMER:
            return {
                ...state,
                items_fetchConsignmentsCustomerInventoryCountReplenish: [],
                items_fetchConsignmentsCustomerInventoryCountEdit: [],
                items_fetchConsignmentsCustomerInventory: [],
                items_fetchConsignmentsCustomer: action.payload,                
                items_fetchUserConsignmentsCustomer: [],
                items_consignmentsCustomerInventoryOnhand: {},
                items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: [],
                items_fetchConsignmentsCustomerInventoryCountReplenishDetail: {}
            }
        case FETCH_CONSIGNMENTS_CUSTOMER_INVENTORY:
            return {
                ...state,
                items_fetchConsignmentsCustomerInventoryCountReplenish: [],
                items_fetchConsignmentsCustomerInventoryCountEdit: [],
                items_fetchConsignmentsCustomerInventory: action.payload,  
                items_fetchConsignmentsCustomer: [],              
                items_fetchUserConsignmentsCustomer: [],
                items_consignmentsCustomerInventoryOnhand: {},
                items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: [],
                items_fetchConsignmentsCustomerInventoryCountReplenishDetail: {}
            }   
        case FETCH_CONSIGNMENTS_CUSTOMER_COUNTEDIT:
            return {
                ...state,
                items_fetchConsignmentsCustomerInventoryCountReplenish: [],
                items_fetchConsignmentsCustomerInventoryCountEdit: action.payload,  
                items_fetchConsignmentsCustomerInventory: [],  
                items_fetchUserConsignmentsCustomer: [],
                 items_consignmentsCustomerInventoryOnhand: {},
                items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: [],
                items_fetchConsignmentsCustomerInventoryCountReplenishDetail: {}
            }     
        case FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH:
            return {
                ...state,
                items_fetchConsignmentsCustomerInventoryCountReplenish: action.payload,
                items_fetchConsignmentsCustomerInventoryCountEdit: [],  
                items_fetchConsignmentsCustomerInventory: [],  
                items_fetchUserConsignmentsCustomer: [],
                items_consignmentsCustomerInventoryOnhand: {},
                items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: []
            }
        case FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL:
            return {
                ...state,
                items_fetchConsignmentsCustomerInventoryCountEdit: [],  
                items_fetchConsignmentsCustomerInventory: [],  
                items_fetchUserConsignmentsCustomer: [],
                items_consignmentsCustomerInventoryOnhand: {},
                items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: [],
                items_fetchConsignmentsCustomerInventoryCountReplenishDetail: action.payload
            }            
        case FETCH_CONSIGNMENTS_CUSTOMER_COUNT_NO_REPLENISH_CUST:
            return {
                ...state,
                items_fetchConsignmentsCustomerInventoryCountReplenish: [],
                items_fetchConsignmentsCustomerInventoryCountEdit: [],  
                items_fetchConsignmentsCustomerInventory: [],  
                items_fetchUserConsignmentsCustomer: [],
                items_consignmentsCustomerInventoryOnhand: {},
                items_fetchConsignmentsCustomerInventoryCountNoReplenishCust: action.payload,
                items_fetchConsignmentsCustomerInventoryCountReplenishDetail: {}
            }                                    
        case CONSIGNMENTS_CUSTOMER_INVENTORY_REPLENISH_CHANGE:
            return {
                ...state,
                items_consignmentsCustomerInventoryReplenishChange: action.payload
            }  

        case CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND:
            return {
                ...state,
                items_consignmentsCustomerInventoryOnhand: action.payload
            }              
        // case RESET_CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND:
        //     return {
        //         ...state,
        //         items_consignmentsCustomerInventoryOnhand: initialState.items_consignmentsCustomerInventoryOnhand
        //     }                     
        case FETCH_USER_CONSIGNMENTS_CUSTOMER:
            return {
                ...state,
                items_fetchConsignmentsCustomer: [],
                items_fetchConsignmentsCustomerInventoryCountReplenish: [],
                items_fetchConsignmentsCustomerInventoryCountEdit: [],
                items_fetchConsignmentsCustomerInventory: [],
                items_fetchUserConsignmentsCustomer: action.payload,
                items_addConsignmentPopup: initialState.items_addConsignmentPopup,
                items_insertConsignmentPopup: initialState.items_insertConsignmentPopup,
                items_fetchConsignmentsCustomerInventoryCountReplenishDetail: {}

            }            
        case FETCH_DELETE_ROW:
            //console.log('consignmentsPostReducer FETCH_DELETE_ROW action:' + JSON.stringify(action));
            return {
                ...state,
                items_fetchConsignmentsCustomerInventory: [],
                items_fetchConsignmentsCustomer: action.payload,                
                items_fetchUserConsignmentsCustomer: []
            }   
        case FETCH_EDIT_ROW:
            //console.log('consignmentsPostReducer FETCH_EDIT_ROW action:' + JSON.stringify(action));
            return {
                ...state,
                items_fetchConsignmentsCustomerInventory: [],
                items_fetchConsignmentsCustomer: action.payload,                
                items_fetchUserConsignmentsCustomer: []
            }  
        case FETCH_INSERT_ITEMS_ROW:
            //console.log('consignmentsPostReducer FETCH_INSERT_ITEMS_ROW action:' + JSON.stringify(action));
            return {
                ...state,
                items_fetchConsignmentsCustomerInventory: [],
                items_fetchConsignmentsCustomer: action.payload,                
                items_fetchUserConsignmentsCustomer: []
            }                
        case ADD_CONSIGNMENT_POPUP:
            //console.log('consignmentsPostReducer ADD_CONSIGNMENT_POPUP action:' + JSON.stringify(action));
            return {
                ...state,                
                items_addConsignmentPopup: action.payload,    
                items_noticeMessage: [],            
            }            
        case FETCH_USER_CUSTOMER_PERMISSIONS:
            return {
                ...state,
                items_fetchUserCustomer: action.payload,                
            }  
        case FETCH_USER_THIRD_PARTY_PERMISSIONS:
            return {
                ...state,
                items_fetchUserThirdParty: action.payload,                
            }   
        case FETCH_ALL_THIRD_PARTY_PERMISSIONS:
            return {
                ...state,
                items_fetchAllThirdParty: action.payload,                
            }                           
        case NOTICE_MESSAGE:
            return {
                ...state,
                items_noticeMessage: action.payload,                
            }                
            
        // case ADD_CONSIGNMENT_POPUP_DEFAULT:
        //     //console.log('consignmentsPostReducer ADD_CONSIGNMENT_POPUP action:' + JSON.stringify(action));
        //     return {
        //         ...state,
        //         items_addConsignmentPopup: initialState.items_addConsignmentPopup,                
        //     } 
        default:
            return state;
    }
}

export default consignmentsPostReducer;